import React, { useState, useEffect } from 'react';
import LoginPage from "./pages/LoginPage";
import StatsPage from './pages/StatsPage';
import UploadCsvPage from './pages/UploadCsvPage';
import VouchersPage from './pages/VouchersPage';
import Navbar from './components/Navbar';
import './App.css';

const API_URL = 'https://api.vouppy.com';

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [page, setPage] = useState("stats");
  const [loginForm, setLoginForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  // ============================================
  // DARK MODE STATE - DODAJ OVO
  // ============================================
  const [theme, setTheme] = useState(
    localStorage.getItem('theme') || 'light'
  );

  // Apply theme to root element
  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);
  // ============================================

  // Podaci iz login odgovora
  const [user, setUser] = useState(null);
  const [organization, setOrganization] = useState(null);
  const [objects, setObjects] = useState([]);
  const [apiKey, setApiKey] = useState(null);

  useEffect(() => {
    setIsLoggedIn(localStorage.getItem("isLoggedIn") === "true");
    if (localStorage.getItem("user")) {
      setUser(JSON.parse(localStorage.getItem("user")));
      setOrganization(JSON.parse(localStorage.getItem("organization")));
      setObjects(JSON.parse(localStorage.getItem("objects")));
      setApiKey(localStorage.getItem("apiKey"));
    }
  }, []);

  const handleLogin = async () => {
    if (!loginForm.username || !loginForm.password) {
      alert('Popuni sva polja');
      return;
    }
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/login/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: loginForm.username,
          password: loginForm.password
        }),
      });

      const data = await response.json().catch(() => ({}));
      if (data.detail) throw new Error(data.detail);

      if (data.role != 'admin') {
        alert('Nemate prava za korišćenje ovog programa! Možete se obratiti na support@vouppy.com');
        return;
      }
      setUser(data);
      const org = data.organizations?.[0] || null;
      setOrganization(org);
      setApiKey(org?.api_key || null);
      setObjects(data.objects || []);
      setIsLoggedIn(true);

      // Čuvamo u localStorage da ostane login posle refresh-a
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("user", JSON.stringify(data));
      localStorage.setItem("organization", JSON.stringify(org));
      localStorage.setItem("objects", JSON.stringify(data.objects || []));
      localStorage.setItem("apiKey", org?.api_key || "");

    } catch (err) {
        alert('❌ Greška: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUser(null);
    setOrganization(null);
    setObjects([]);
    setApiKey(null);
    // NE BRIŠEMO THEME IZ localStorage
    const savedTheme = localStorage.getItem('theme');
    localStorage.clear();
    if (savedTheme) localStorage.setItem('theme', savedTheme);
  };

  if (!isLoggedIn) {
    return (
      <LoginPage
        loginForm={loginForm}
        setLoginForm={setLoginForm}
        handleLogin={handleLogin}
        loading={loading}
        theme={theme}          // ← Prosledi theme
        setTheme={setTheme}    // ← Prosledi setTheme
      />
    );
  }

  return (
    <>
      <Navbar
        user={user}
        organization={organization}
        objects={objects}
        onLogout={handleLogout}
        page={page}
        setPage={setPage}
        theme={theme}          // ← Prosledi theme navbar-u
        setTheme={setTheme}    // ← Prosledi setTheme navbar-u
      />
      {page === "stats" && (
          <StatsPage
            apiKey={organization.api_key}
            organizationId={organization.organization_id}
          />
        )}
      {page === "upload" && (
        <UploadCsvPage
          userId={user.user_id}
          objectId={user.object_id}
          apiKey={apiKey}
          organizationId={organization.organization_id}
        />
      )}
      {page === "vouchers" && (
          <VouchersPage
            apiKey={organization.api_key}
            organizationId={organization.organization_id}
          />
        )}
    </>
  );
}